import React from 'react';
import useDeviceType from '../../../hooks/useDeviceType';
import SignupBanner from '../../../assets/sectionBanners/Mid_Banner_WEB.webp';
import SignupBannerMob from '../../../assets/sectionBanners/Mid_Banner_MOB.webp';
import SignupBannerTablet from '../../../assets/sectionBanners/Mid_Banner_TABLET.webp';
import ImageBanner from '../../ImageBanner/ImageBanner';
import { links } from '../../../lib/constants';
import { isRightToLeftDirection } from '../../../util/utils';
import Link from '../../Link/Link';

const SectionBannerSignup = ({ t, baseClassName, navigate }) => {
    const { isMobileWidth, isTablet } = useDeviceType();

    return (
        <div
            className={`${baseClassName}__signup-container ${
                isRightToLeftDirection
                    ? `${baseClassName}__signup-container-rtl`
                    : ''
            }`}
        >
            <ImageBanner
                image={SignupBanner}
                mobileImage={SignupBannerMob}
                tabletImage={SignupBannerTablet}
                maxFontSize={23}
                lineHeightRatio={1.5}
            >
                <div
                    className={`${baseClassName}__signup ${
                        isRightToLeftDirection
                            ? `${baseClassName}__signup-rtl`
                            : ''
                    } ${isTablet ? `${baseClassName}__signup-tablet` : ''} ${
                        isMobileWidth ? `${baseClassName}__signup-mobile` : ''
                    }`}
                >
                    <h2 className={`${baseClassName}__signup_title`}>
                        {t('Section.Banner.Signup.title')}
                    </h2>
                    <div className={`${baseClassName}__signup_description`}>
                        {t('Section.Banner.Signup.description')}
                    </div>
                    <ul
                        className={
                            isRightToLeftDirection
                                ? `${baseClassName}__signup_benefits_rtl`
                                : `${baseClassName}__signup_benefits`
                        }
                    >
                        <li>{t('Section.Banner.Signup.benefit1')}</li>
                        <li>{t('Section.Banner.Signup.benefit2')}</li>
                        <li>{t('Section.Banner.Signup.benefit3')}</li>
                        <li>{t('Section.Banner.Signup.benefit4')}</li>
                        <li>{t('Section.Banner.Signup.benefit5')}</li>
                    </ul>

                    <Link href={links.signup()}>
                        <button
                            className={`${baseClassName}__signup_cta`}
                        >
                            {t('Section.Banner.Signup.cta')}
                        </button>
                    </Link>
                </div>
            </ImageBanner>
        </div>
    );
};

export default SectionBannerSignup;
